import React from 'react'

export const StressLess = () => (
  <svg
    width="38"
    height="40"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5 6.27734L10 10.9996M10 10.9996L1.49997 6.27734M10 10.9996V20.4996M19 10.9996V6.94104C19 6.5984 19 6.42708 18.9495 6.27428C18.9049 6.1391 18.8318 6.01502 18.7354 5.91033C18.6263 5.79199 18.4766 5.70879 18.177 5.54239L10.777 1.43128C10.4934 1.27372 10.3516 1.19494 10.2015 1.16405C10.0685 1.13672 9.9315 1.13672 9.7986 1.16405C9.6484 1.19494 9.5066 1.27372 9.223 1.43128L1.82297 5.54239C1.52345 5.70879 1.37368 5.79199 1.26463 5.91033C1.16816 6.01502 1.09515 6.1391 1.05048 6.27428C1 6.42708 1 6.5984 1 6.94104V15.0581C1 15.4008 1 15.5721 1.05048 15.7249C1.09515 15.8601 1.16816 15.9842 1.26463 16.0888C1.37368 16.2072 1.52346 16.2904 1.82297 16.4568L9.223 20.5679C9.5066 20.7255 9.6484 20.8042 9.7986 20.8351C9.9315 20.8625 10.0685 20.8625 10.2015 20.8351C10.3516 20.8042 10.4934 20.7255 10.777 20.5679L11 20.444M5.5 3.49959L14.5 8.49959M20 20.4996L19 19.4996M20 16.9996C20 18.6564 18.6569 19.9996 17 19.9996C15.3431 19.9996 14 18.6564 14 16.9996C14 15.3427 15.3431 13.9996 17 13.9996C18.6569 13.9996 20 15.3427 20 16.9996Z"
      stroke="#181B19"
      strokeWidth=".8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
